// extracted by mini-css-extract-plugin
module.exports = {"useTranslationButton":"ExpandCell_useTranslationButton__JnEYi","link":"ExpandCell_link__MENUE"};